import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-edit-learnset',
  templateUrl: './edit-learnset.component.html',
  styleUrls: ['./edit-learnset.component.scss'],
  standalone: false
})
export class EditLearnsetComponent {

  @Input() learnset?: Learnset;
  @Output() actionFinished: EventEmitter<any> = new EventEmitter<any>();

  form!: FormGroup;
  isSaving: boolean = false;

  constructor(
    private learnsetService: LearnsetService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      learnsetName: ['', [Validators.required]],
    });
  }

  ngOnChanges() {
    if (this.learnset) {
      this.form.setValue({learnsetName: this.learnset.name});
    }
  }

  updateLearnset() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.isSaving = true;
    this.learnset!.name = this.form.get('learnsetName')?.value;
    this.learnsetService.updateLearnset(this.learnset!).subscribe(() => {
      this.isSaving = false;
      this.actionFinished.emit();
    });
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
